export const NAME = 'loginFb';